import type { SVGProps } from 'react';

export const VisibilityStandard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    role="img"
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{'visibility standard'}</title>
    <path
      d="M50,80.85C15.4,80.85,1.24,52.36.65,51.15L.1,50l.56-1.14c.59-1.21,15-29.71,49.34-29.71s48.75,28.5,49.34,29.71L99.92,50l-.59,1.17C98.71,52.41,83.82,80.85,50,80.85ZM6,50c2.91,5.18,16.16,25.6,44,25.6,27.23,0,41-20.41,44-25.63-3-5.22-16.39-25.61-44-25.61S8.91,44.84,6,50Z"
      fill={props.fill}
    />
    <path
      d="M50.52,80.85A30.85,30.85,0,1,1,81.36,50,30.88,30.88,0,0,1,50.52,80.85Zm0-56.47A25.62,25.62,0,1,0,76.14,50,25.64,25.64,0,0,0,50.52,24.38Z"
      fill={props.fill}
    />
    <path
      d="M37,49.26A13.49,13.49,0,1,0,50.52,35.77,13.48,13.48,0,0,0,37,49.26Z"
      fill={props.fill}
    />
    <path
      d="M99.34,48.86C98.76,47.67,85,20.5,52.39,19.22c-.62,0-1.24-.07-1.87-.07H50C15.65,19.15,1.25,47.65.66,48.86L.1,50l.55,1.15C1.24,52.36,15.4,80.85,50,80.85h.52c.64,0,1.26,0,1.89-.07,32.11-1.31,46.31-28.4,46.92-29.58L99.92,50ZM76.14,50A25.65,25.65,0,0,1,52,75.58l-1.75,0a25.62,25.62,0,0,1,0-51.24l1.74,0A25.66,25.66,0,0,1,76.14,50ZM6,50A53.26,53.26,0,0,1,27.37,29.66a30.74,30.74,0,0,0,.09,40.78A52.46,52.46,0,0,1,6,50ZM74.71,69.1a30.77,30.77,0,0,0-.16-38.41A53.45,53.45,0,0,1,94,50,55.25,55.25,0,0,1,74.71,69.1Z"
      fill={props.fill}
    />
  </svg>
);
